import { render, staticRenderFns } from "./rdsmstest.vue?vue&type=template&id=2744cac5&"
import script from "./rdsmstest.vue?vue&type=script&lang=js&"
export * from "./rdsmstest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports